




































import Vue from 'vue';

import {
    Code,
} from '@webapp/helpers/aria';

export default Vue.extend({
    name: 'goal-dropdown',
    props: {
        // Disabled status
        disabled: {
            type: Boolean,
            required: true,
        },
        // Current value
        value: {
            type: Number,
            required: false,
            default: null,
        },
        // An array of option
        options: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            isExpanded: false,
        };
    },
    computed: {
        displayedValue() {
            return this.value ?? '+';
        },

        buttonClass() {
            return [
                'goal-dropdown__button', {
                    'goal-dropdown__button--selected': this.value !== null && !this.isExpanded,
                    'goal-dropdown__button--focused': this.isExpanded,
                },
            ];
        },
    },
    methods: {
        openDropdown(event: MouseEvent) {
            event.preventDefault();

            this.isExpanded = true;

            const optionsElements = Object.keys(this.$refs).reduce((acc: HTMLElement[], key) => {
                if (key.startsWith('option_')) {
                    acc.push(this.$refs[key][0]);
                }

                return acc;
            }, []);

            if (this.value !== null) {
                const selectedOptionEl = optionsElements
                    .find((el) => Number(el.textContent) === this.value);

                if (!selectedOptionEl) {
                    return;
                }

                this.$nextTick(() => selectedOptionEl.focus());

                return;
            }

            const defaultOption = optionsElements.find((el) => Number(el.textContent) === 0);

            if (!defaultOption) {
                return;
            }

            this.$nextTick(() => defaultOption.focus());
        },

        closeDropdown() {
            if (this.isExpanded) {
                this.isExpanded = false;
            }
        },

        handleSelect(option: string[]) {
            this.$emit('select', option);
            this.closeDropdown();
        },

        handleElementSelect() {
            const currentFocusedElement = document.activeElement;

            if (!currentFocusedElement) {
                return;
            }

            const selectedValue = Number(currentFocusedElement.textContent);

            if (this.options.includes(selectedValue)) {
                this.handleSelect(selectedValue);
            }
        },

        focusPrevious(event: KeyboardEvent) {
            const { previousElementSibling } = (event.target as HTMLElement);

            if (previousElementSibling) {
                (previousElementSibling as HTMLElement).focus();
            }
        },

        focusNext(event: KeyboardEvent) {
            const { nextElementSibling } = (event.target as HTMLElement);

            if (nextElementSibling) {
                (nextElementSibling as HTMLElement).focus();
            }
        },

        handleKeyPress(event: KeyboardEvent) {
            if (!this.isExpanded) {
                return;
            }

            switch (event.code) {
                case Code.Escape:
                    return this.closeDropdown();
                case Code.Enter:
                case Code.Space:
                    return this.handleElementSelect();
                case Code.ArrowUp:
                    return this.focusPrevious(event);
                case Code.ArrowDown:
                    return this.focusNext(event);
                default:
                    break;
            }
        },

        isOptionSelected(option: number): boolean {
            return this.value === option;
        },
    },
});
